<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Billing Payment/History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Billing Status</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <router-link class="back-link d-none" :to="{ name: 'dashboard' }"
          ><i class="fas fa-chevron-left"></i> Back</router-link
        >
        <div class="row">
          <!-- <div class="col-md-12">
            <div class="card paybill">
              <div class="paybill-head">
                <h5>Last date to pay bill: {{ value.billDueDate }}</h5>
              </div>
              <div class="paybill-body">
                <ul>
                  <li>
                    My Package: <span>{{ value.package }}</span>
                  </li>
                  <li>
                    Monthly Bill: <span>{{ value.monthlyAmount }}</span>
                  </li>
                  <li>
                    Available Balance: <span>{{ value.availableBalance }}</span>
                  </li>
                  <li>
                    Total bill <span>{{ value.monthlyAmount }}</span>
                  </li>
                </ul>
                <a
                  href="javascript:void(0)"
                  @click="otherPayment"
                  class="btn pay-other"
                  >Pay Now</a
                >
              </div>
            </div>
          </div> -->

          <!-- <div class="col-md-5">
            <div class="card paybill">
              <div class="paybill-head">
                <h5>Last date to pay bill: {{ value.billDueDate }}</h5>
              </div>
              <div class="paybill-body">
                <ul>
                  <li>
                    My Package: <span>{{ value.package }}</span>
                  </li>
                  <li>
                    Monthly Bill: <span>{{ value.monthlyAmount }}</span>
                  </li>
                  <li>
                    Available Balance: <span>{{ value.availableBalance }}</span>
                  </li>
                  <li>
                    Total bill <span>{{ value.monthlyAmount }}</span>
                  </li>
                </ul>
                <a
                  href="javascript:void(0)"
                  @click="otherPayment"
                  class="btn pay-other"
                  >Pay Now</a
                >
              </div>
            </div>
          </div> -->

          <div class="col-md-12">
            <div class="card common-card payment-history">
              <h5>Payment History</h5>
              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table common-table">
                    <thead>
                      <tr>
                        <th class="col-md-3 text-left">Transaction ID</th>
                        <th class="col-md-3 text-left">Payment Date</th>
                        <th class="col-md-3 text-center">Amount (£)</th>
                        <th class="col-md-3 text-right">Status</th>
                      </tr>
                    </thead>
                    <tbody class="users-list">
                      <tr
                        v-for="{
                          payment_time,
                          index,
                          total_amount,
                          payment_status,
                          mer_transactionid,
                          class_name,
                        } in list.data"
                        :key="index"
                      >
                        <td class="text-left">
                          {{
                            !_.isEmpty(mer_transactionid)
                              ? mer_transactionid
                              : ""
                          }}
                        </td>
                        <td class="text-left">
                          {{ payment_time }}
                        </td>
                        <td class="text-center">
                          <span class="amount">
                            {{ total_amount }}
                          </span>
                        </td>
                        <td class="text-right">
                          <span :class="['badge', class_name]">
                            {{
                              !_.isEmpty(payment_status) ? payment_status : ""
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  class="p-4"
                  v-if="_.isEmpty(list.data) && !list.is_loading"
                >
                  <div class="alert alert-default-warning" role="alert">
                    No data found!
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <vue-pagination
                  :pagination="list"
                  v-if="list.total > list.per_page"
                  @paginate="getRechargeList()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
span.amount {
  font-weight: 800;
  font-size: 14px;
  color: black;
}

.badge {
  color: white !important;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "Payment",
  metaInfo: {
    title: "Payment | Dotlines",
  },

  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    value: {
      package: "",
      monthlyAmount: "",
      availableBalance: "",
      billDueDate: "",
    },

    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [
        // {
        //     mer_transactionid: "TXN454580590880",
        //     payment_time: "2023-11-01 13:47:28",
        //     payment_status: "PAID",
        //     total_amount: "15.00"
        // },
      ],
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var sidebarElem = window.$(document).find(".sidebar-mini");
      if ($(sidebarElem).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    this.getPackageInfo();

    this.api_url = "/admin_users";
    this.getRechargeList();
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getRechargeList();
    });
  },
  methods: {
    getRechargeList() {
      this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      this.list.data = [];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        query.cuid = subscriber.username;
        // console.log("QueryParams::", query);
        axios({
          method: "get",
          url: "/get-recharge-history",
          params: query,
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => {
            //console.log("Res::", response)
            this.list = response.data;
            this.list.data =
              this.list.data.length > 0
                ? this.list.data.map((o) => {
                    o.payment_time = moment(o.payment_time).format(
                      "DD/MM/YYYY"
                    );
                    o.class_name =
                      o.payment_status == "PAID"
                        ? "badge-success"
                        : "badge-warning";
                    return o;
                  })
                : [];
            // this.list.total = data.length;
            // console.log("list data::", this.list)
            this.list.is_loading = false;
          })
          .catch((error) => {
            this.list.is_loading = false;
          });
      }
    },
    bikashPayment: function () {
      console.log("Bikash Payment");
      this.$router.push({
        name: "paynow",
        params: { paymentType: "bKashMFS" },
      });
      // this.$router.push({ name: "paynow" });
    },

    otherPayment: function () {
      console.log("Other Payment");
      this.$router.push({ name: "paynow" });
    },

    getPackageInfo: function () {
      let api_url = "/get-bill-info";
      let _this = this;
      _this.is_loading = true;
      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      console.log("Subscriber::", subscriber);
      if (subscriber) {
        axios
          .get(api_url, { params: { cuid: subscriber.username } })
          .then((response) => {
            //console.log('response.data::', response.data);
            response.data.monthlyAmount =
              "£ " +
              parseFloat(response.data.monthlyAmount).toLocaleString("en-US", {
                maximumFractionDigits: 2,
              });
            response.data.billDueDate = moment(
              response.data.billDueDate
            ).format("DD/MM/YYYY");
            response.data.availableBalance =
              "£ " +
              parseFloat(response.data.availableBalance).toLocaleString(
                "en-US",
                {
                  maximumFractionDigits: 2,
                }
              );
            _this.value = response.data;
            _this.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.is_loading = false;
          });
      }
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getInvoiceData() {
      var _this = this;
      this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      this.list.data = [];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);

      if (subscriber) {
        query.cuid = subscriber.username;
        axios
          .get(_this.api_url, { params: query })
          .then((response) => {
            console.log("response.data::", response.data);
            var paidInvoices = response.data.data;
            paidInvoices = paidInvoices
              .filter((o) => o.amount > 0)
              .sort((a, b) => {
                if (b.payments.length > 0 && a.payments.length > 0) {
                  return (
                    moment(b.payments[0].paymentDate) -
                    moment(a.payments[0].paymentDate)
                  );
                } else return -1;
              })
              .slice(0, 10);

            paidInvoices = paidInvoices.map((o) => {
              return {
                paymentId:
                  o.payments.length > 0 ? o.payments[0].paymentId : "NA",
                paymentDate:
                  o.payments.length > 0
                    ? moment(o.payments[0].paymentDate).format("DD MMM YYYY")
                    : "NA",
                billAmount: (
                  parseFloat(Math.abs(o.amount)) / 100
                ).toLocaleString("en-US", { maximumFractionDigits: 2 }),
                //  dueDate: moment(o.payments[0].paymentDate).format('DD-MM-YYYY'),
                status: o.status,
              };
            });

            console.log("Mapped Data::", paidInvoices);

            _this.list.data = paidInvoices;
            _this.list.total = paidInvoices.length;
            _this.list.per_page = 5;
            _this.list.from = 1;
            _this.list.to =
              parseInt(paidInvoices.length / _this.list.per_page) + 1;

            _this.list.is_loading = false;
          })
          .catch((error) => {
            console.log("error " + error);
            _this.list.is_loading = false;
          });
      }
    },

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getInvoiceData();
    },
  },
};
</script>
